import api from "../service/api"; // your axios instance

// ✅ CREATE COMPLAINT
export const createComplaint = (data) => {
  return api.post("/store/complaint", data);
};

// ✅ GET COMPLAINTS (your given API)
export const getComplaints = (
  scholarId,
  page = 1,
  perPage = 10,
  status = "all",
  search = ""
) => {
  let url = `/scholar/complaints/${scholarId}?page=${page}&per_page=${perPage}`;

  if (status !== "all") {
    url += `&status=${status}`;
  }

  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }

  return api.get(url);
};




export const updateRating = (id, data) => {
  return api.post(`/update-rating/${id}`, data);
};

export const deleteComplaint = (id) => {
  return api.delete(`/complaint/delete/${id}`);
};